import React from "react";
import { Field, ErrorMessage } from "formik";
import { FaCalendarAlt, FaUser, FaEnvelope, FaPhone, FaGamepad, FaMoneyBillWave, FaTag } from "react-icons/fa";
import FormField from "../components/FormField";
import Rules from "../components/Rules";
import InfoTooltip from "../components/InfoTooltip";
import { Checkbox } from "../components/ui/checkbox";
import { cn } from "../lib/utils";

const RecapItem = ({ label, value, icon: Icon }) => {
  if (!value) return null;
  return (
    <div className="flex items-center gap-3 py-2 border-b border-border/20 last:border-0">
      {Icon && <Icon className="h-3 w-3 text-primary shrink-0" />}
      <span className="text-xs text-muted-foreground w-24 shrink-0">{label}</span>
      <span className="text-xs font-medium text-foreground flex-1 truncate">{value}</span>
    </div>
  );
};

export const Step4 = ({ values, isInvited = false }) => (
  <div className="h-full flex flex-col gap-4 step-enter">

    <div>
      <h2 className="text-base font-bold text-foreground">Confirmation</h2>
      <p className="text-xs text-muted-foreground mt-0.5">Vérifiez vos informations et approuvez le règlement.</p>
    </div>

    {/* Règlement intérieur */}
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between px-4 py-3 rounded-xl border border-border/50 bg-muted/15 hover:border-primary/30 transition-colors">
        <Field name="reglementInterieurLu">
          {({ field, form }) => (
            <label className="flex items-center gap-3 cursor-pointer select-none flex-1">
              <Checkbox
                id="reglementInterieurLu"
                checked={field.value === true}
                onCheckedChange={(v) => form.setFieldValue("reglementInterieurLu", v)}
              />
              <span className={cn(
                "text-sm leading-snug",
                field.value ? "text-foreground" : "text-muted-foreground"
              )}>
                Le règlement intérieur est lu et approuvé.{" "}
                <span className="text-secondary font-bold">*</span>
              </span>
            </label>
          )}
        </Field>
        <div className="flex items-center gap-3 ml-4 shrink-0">
          <Rules />
          <InfoTooltip
            title="Information importante !"
            text="Merci de lire le règlement. Il contient les règles à suivre pour garantir une bonne ambiance au sein de notre communauté. Votre adhésion implique le respect de ces règles."
          />
        </div>
      </div>
      <ErrorMessage name="reglementInterieurLu" component="p" className="text-[10px] text-destructive" />
    </div>

    {/* Date de signature */}
    <FormField
      name="dateSignature"
      label="Date de signature"
      icon={FaCalendarAlt}
      type="date"
      required
    />

    {/* Récapitulatif */}
    <div className="flex-1 min-h-0 rounded-xl border border-border/40 bg-muted/10 px-4 py-3 overflow-hidden">
      <p className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest mb-2">
        Récapitulatif
      </p>
      <RecapItem label="Nom"         value={values.nom}                            icon={FaUser}          />
      <RecapItem label="Prénom"      value={values.prenom}                         icon={FaUser}          />
      <RecapItem label="Pseudo"      value={values.pseudo}                         icon={FaUser}          />
      <RecapItem label="Email"       value={values.email}                          icon={FaEnvelope}      />
      <RecapItem label="Téléphone"   value={values.telephone}                      icon={FaPhone}         />
      <RecapItem label="Domaine(s)"  value={values.domainePratique?.join(", ")}   icon={FaGamepad}       />
      {!isInvited && <RecapItem label="Statut"    value={values.statut}        icon={FaTag}           />}
      {!isInvited && <RecapItem label="Paiement"  value={values.modePaiement}  icon={FaMoneyBillWave} />}
    </div>
  </div>
);
